import { render, staticRenderFns } from "./ReportEntitys.vue?vue&type=template&id=00674068&"
import script from "./ReportEntitys.vue?vue&type=script&lang=js&"
export * from "./ReportEntitys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports